<mat-form-field appearance="fill">
	<mat-label>
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="13"> </mat-spinner>
		</mat-icon>
		Select Roles
	</mat-label>
	<mat-select #selRoleSelect placeholder="Select Roles" [formControl]="roleSelect" multiple
		[panelClass]="'panel-location-region'" (selectionChange)="selected($event)">
		<mat-select-trigger>
			{{roleSelect.value?.[0]?.NAME || ''}}
			<span *ngIf="(roleSelect.value?.length || 0) > 1" class="example-additional-selection">
				(+{{(roleSelect.value?.length || 0) - 1}} {{roleSelect.value?.length === 2 ? 'other' : 'others'}})
			</span>

		</mat-select-trigger>
		<div class="margin-md text-center" class="row">
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
				<button color="primary" mat-raised-button (click)="toggleAllSelection(selRoleSelect,true)" style="font-size:6px !important;padding: 3px 5px;">
					Select All
				</button>
			</div>
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
				<button color="accent" mat-raised-button (click)="toggleAllSelection(selRoleSelect,false)" style="font-size:6px !important;padding: 3px 5px;">
					Deselect All
				</button>
			</div>
		</div>

		<div class="text-center margin-md" *ngIf="isLoading">
			<mat-icon>
				<mat-spinner diameter="13"> </mat-spinner>
			</mat-icon>
			Loading
		</div>

		<div class="scrollable-panel-location">
			<mat-option *ngFor="let role of this.roles" [value]="role">
				{{role.NAME}}
			</mat-option>
		</div>
	</mat-select>

</mat-form-field>